<template>
  <div class="body-content">
    <h1 class="title">Dashboard</h1>

    <!--<add-inspection-grid ></add-inspection-grid>
    <add-damage save="saves" v-on:save-clicked="increment"></add-damage>-->

    <!-- 4-column widgets grid -->
    <div class="widgets-grid">
      <div class="widget-card">
        <h3>Active VCNs</h3>
        <div class="widget-count" v-if="!isLoadingActiveVCNs" @click="openVCNModal" style="cursor:pointer">{{
          activeVCNs.length }}</div>
        <div v-if="isLoadingActiveVCNs">Loading...</div>
      </div>
      <div class="widget-card">
        <h3>Import Lists</h3>
        <div class="widget-count" v-if="!isLoadingactiveImortVCNs" @click="openImportVcnModal" style="cursor:pointer">{{
          activeImortVCNs.length }}</div>
        <div v-if="isLoadingactiveImortVCNs">Loading...</div>
      </div>
      <!--<div class="widget-card" v-for="n in 7" :key="n">
        <h3>Widget {{ n + 1 }}</h3>
        <p>Placeholder content</p>
      </div>-->
    </div>

    <!-- Active VCNs Modal -->
    <div v-if="showVCNModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Active VCNs ({{ activeVCNs.length }}) </h3>
          <div class="search-inline">
            <label class="search-label">Search</label>
            <input type="text" v-model="activeSearch" placeholder="VCN / Vessel / Voyage / Area" class="search-input" />
          </div>
          <button class="close-btn" @click="closeVCNModal">&times;</button>
        </div>
        <div class="modal-body">
          <table class="vcns-table">
            <thead>
              <tr>
                <th>#</th>
                <th>VCN</th>
                <th>Vessel</th>
                <th>IMP Voyage</th>
                <th>EXP Voyage</th>
                <th>Area</th>
                <th>IS Sail</th>
                <th>Sail Date</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vcn, idx) in filteredActiveVCNs" :key="vcn.vcn || vcn.id || idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ vcn.vcnName }}</td>
                <td>{{ vcn.VesselName }}</td>
                <td>{{ vcn.import_voyageName }}</td>
                <td>{{ vcn.export_voyageName }}</td>
                <td>{{ vcn.area }}</td>
                <td>{{ vcn.IsSail ? 'Yes' : 'No' }}</td>
                <td>{{ vcn.SailDate }}</td>
                <td>
                  <button class="edit-button" @click="editVCN(vcn)">Edit</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button class="cancel-button" @click="closeVCNModal">Close</button>
        </div>
      </div>
    </div>
    <!-- Advance List Modal (moved to be nested inside Import VCNs modal) -->
    <!-- Import VCNs Modal -->
    <div v-if="showImportVcnModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Import VCNs ({{ activeImortVCNs.length }})</h3>
          <div class="search-inline">
            <label class="search-label">Search</label>
            <input type="text" v-model="importSearch" placeholder="VCN / Vessel / Voyage / Area" class="search-input" />
          </div>
          <button class="close-btn" @click="closeImportVcnModal">&times;</button>
        </div>
        <div class="modal-body">
          <table class="vcns-table">
            <thead>
              <tr>
                <th>#</th>
                <th>VCN</th>
                <th>Vessel</th>
                <th>IMP Voyage</th>
                <th>Area</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vcn, idx) in filteredImportVCNs" :key="vcn.vcnID || vcn.vcnName || idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ vcn.vcnName }}</td>
                <td>{{ vcn.VesselName }}</td>
                <td>{{ vcn.import_voyageName }}</td>
                <td>{{ vcn.area }}</td>
                <td>
                  <button class="edit-button" style="margin-left:8px; background:#6f42c1;"
                    @click="showSavanceList(vcn)">Advance List</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Nested Advance List modal rendered on top of the Import VCN modal -->
        <div v-if="showAdvanceModal" class="nested-modal-overlay">
          <div class="nested-modal-content">
            <div class="modal-header">
              <h3>Advance List ({{ advanceListData.length }})</h3>
              <button class="close-btn" @click="closeAdvanceModal">&times;</button>
            </div>
            <div class="modal-body">
              <div v-if="isLoadingAdvanceList">Loading...</div>
              <table v-else class="vcns-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>VCN</th>
                    <th>vessel</th>
                    <th>Voyage</th>
                    <th>Applicant</th>
                    <th>Account</th>
                    <th>No Of Container</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in advanceListData" :key="row.id || row.vcnName || idx">
                    <td>{{ idx + 1 }}</td>
                    <td>{{ row.vcnName || row.VCN || row.vcn || '' }}</td>
                    <td>{{ row.VesselName || row.vesselName || '' }}</td>
                    <td>{{ row.VoyageName || row.voyageName || row.import_voyageName || '' }}</td>
                    <td>{{ row.ApplicantName || row.applicantName || '' }}</td>
                    <td>{{ row.AccountName || row.accountName || '' }}</td>
                    <td>{{ row.no_of_container ?? row.count ?? row.no_of_containers ?? '' }}</td>
                  </tr>
                  <tr v-if="advanceListData.length === 0">
                    <td colspan="7">No records found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button class="cancel-button" @click="closeAdvanceModal">Close</button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-button" @click="closeImportVcnModal">Close</button>
        </div>
      </div>
    </div>

    <!-- Edit VCN Modal -->
    <div v-if="showEditModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Edit VCN</h3>
          <button class="close-btn" @click="closeEditModal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="edit-grid">
            <label>VCN</label>
            <input v-model="newVcn.vcnName" />
            <label>Vessel</label>
            <input v-model="newVcn.VesselName" />
            <label>IMP Voyage</label>
            <input v-model="newVcn.import_voyageName" />
            <label>EXP Voyage</label>
            <input v-model="newVcn.export_voyageName" />
            <label>Area</label>
            <input v-model="newVcn.area" />
            <label>Is Sail</label>
            <input type="checkbox" v-model="newVcn.IsSail" :true-value="1" :false-value="0" />
            <label>Sail Date</label>
            <input type="text" v-model="newVcn.SailDate" @blur="setValueToFiled()" placeholder="dd/mm/yyyy"
              :disabled="!newVcn.IsSail" />
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-button" @click="closeEditModal">Cancel</button>
          <button class="save-button" @click="saveEdit" :disabled="isSavingEdit">Save</button>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'
//import AddDamage from '/src/components/AddDamage.vue';
//import AddInspectionGrid from '/src/components/AddInspectionGrid.vue';
export default {
  components: {
    //AddDamage,
    //AddInspectionGrid,
  },
  created() {
    // Intentionally left empty — data fetching is deferred to mounted() so it runs in background
  },

  mounted() {
    // Defer non-critical fetching until after the full page load so it runs in background
    const runBackgroundFetches = () => {
      try {
        const tasks = [
          this.fetchStates(),
          this.fetchCountries(),
          this.fetchBanks(),
          this.fetchCFS(),
          this.fetchLocations(),
          this.fetchVessels(),
          this.fetchVoyages(),
          this.fetchApplicants(),
          this.fetchAccounts(),
          this.fetchLinkedParty(),
          this.fetchMovements(),
          this.fetchPorts(),
          this.fetchMasterLocations(),
          this.fetchActiveVCNs(),
          this.fetchActiveImportVCNs(),
        ];
        // Run all fetches concurrently and don't block render; log results when done
        Promise.allSettled(tasks).then(results => {
          // log results so eslint doesn't complain about unused variable and for debugging
          console.log('Background data fetches completed', results);
        });
      } catch (e) {
        // last-resort: call each fetch without blocking
        try {
          this.fetchStates();
          this.fetchCountries();
          this.fetchBanks();
          this.fetchCFS();
          this.fetchLocations();
          this.fetchVessels();
          this.fetchVoyages();
          this.fetchApplicants();
          this.fetchAccounts();
          this.fetchLinkedParty();
          this.fetchMovements();
          this.fetchPorts();
          this.fetchMasterLocations();
          this.fetchActiveVCNs();
          this.fetchActiveImportVCNs();
        } catch (ee) {
          console.warn('Background fetch fallback failed', ee);
        }
      }
    };

    const schedule = () => {
      if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        window.requestIdleCallback(runBackgroundFetches, { timeout: 3000 });
      } else {
        setTimeout(runBackgroundFetches, 600);
      }
    };

    if (typeof window !== 'undefined') {
      if (document.readyState === 'complete') {
        schedule();
      } else {
        window.addEventListener('load', schedule, { once: true });
      }
    } else {
      // server-side or unknown environment: call directly
      schedule();
    }
  },
  data() {
    return {
      activeVCNs: [],
      activeImortVCNs: [],
      importSearch: '',
      activeSearch: '',
      isLoadingActiveVCNs: false,
      isLoadingactiveImortVCNs: false,
      showImportVcnModal: false,
      showVCNModal: false,
      showEditModal: false,
      showAdvanceModal: false,
      advanceListData: [],
      isLoadingAdvanceList: false,
      isSavingEdit: false,
      newVcn: {
        vcnNo: '',
        vcnName: '',
        vesselID: 0,
        VesselName: '',
        import_voyage: 0,
        import_voyageName: '',
        export_voyage: 0,
        export_voyageName: '',
        MlocID: 0,
        area: '',
        ImpRotNo: '',
        ImpRotDate: null,
        ExpRotNo: '',
        ExpRotDate: null,
        BerthDate: null,
        EgmDate: null,
        IsSail: false,
        SailDate: null,
        vesselLocation: 0,
        Vesselarea: 0,
      },
    };
  },
  computed: {
    filteredImportVCNs() {
      const q = (this.importSearch || '').toString().trim().toLowerCase();
      if (!q) return this.activeImortVCNs;
      return this.activeImortVCNs.filter(vcn => {
        const vcnName = (vcn.vcnName || vcn.vcn || '').toString().toLowerCase();
        const vessel = (vcn.VesselName || vcn.vesselName || '').toString().toLowerCase();
        const voyage = (vcn.import_voyageName || vcn.VoyageName || vcn.voyageName || '').toString().toLowerCase();
        const area = (vcn.area || '').toString().toLowerCase();
        return vcnName.includes(q) || vessel.includes(q) || voyage.includes(q) || area.includes(q);
      });
    }
    ,
    filteredActiveVCNs() {
      const q = (this.activeSearch || '').toString().trim().toLowerCase();
      if (!q) return this.activeVCNs;
      return this.activeVCNs.filter(vcn => {
        const vcnName = (vcn.vcnName || vcn.vcn || '').toString().toLowerCase();
        const vessel = (vcn.VesselName || vcn.vesselName || '').toString().toLowerCase();
        const voyage = (vcn.import_voyageName || vcn.VoyageName || vcn.voyageName || '').toString().toLowerCase();
        const area = (vcn.area || '').toString().toLowerCase();
        return vcnName.includes(q) || vessel.includes(q) || voyage.includes(q) || area.includes(q);
      });
    }
  },
  methods: {
    //increment(damagedata) {
    //  alert("clicked")
    //  console.log(damagedata);
    //},
    openVCNModal() {
      this.showVCNModal = true;
    },
    closeVCNModal() {
      this.showVCNModal = false;
    },
    openImportVcnModal() {
      this.showImportVcnModal = true;
    },
    closeImportVcnModal() {
      this.showImportVcnModal = false;
    },
    setValueToFiled() {
      //console.log('Validating SailDate:', this.newVcn);
      //console.log('Validating SailDate:', this.newVcn.SailDate);

      if (this.newVcn.SailDate != '' && this.newVcn.SailDate != null) {
        if (cs.isvalidDate(this.newVcn.SailDate) == false) {
          useToast().error('Invalid Date');
        }
      }
    },
    editVCN(vcn) {
      // open edit modal with a shallow copy to avoid mutating list before save
      this.newVcn = Object.assign({}, vcn);
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
      this.newVcn = null;
    },
    closeAdvanceModal() {
      this.showAdvanceModal = false;
      this.advanceListData = [];
    },
    async showSavanceList(vcn) {
      // Action handler for Advance List button - call API to get advance list count by VCN
      const toast = useToast();
      console.log('ShowSavance List clicked for VCN:', vcn);
      const vcnId = vcn.vcnID || vcn.vcn || vcn.id;
      if (!vcnId) {
        toast.error('VCN id not found for Advance List.');
        return;
      }

      const token = localStorage.getItem('access_token');
      const config = token ? { headers: { accept: 'application/json', Authorization: `Bearer ${token}` } } : {};
      try {
        this.isLoadingAdvanceList = true;
        // This endpoint appears to return the advance list rows; use it to populate modal table
        const res = await axios.get(`/get_advancelist_count_byvcn/${vcnId}/`, config);
        let payload = res.data;
        let data = Array.isArray(payload) && payload.length >= 3 ? payload[2] : payload;
        // If API returns an object with a nested array, try common keys
        if (data && typeof data === 'object' && !Array.isArray(data)) {
          // common wrapper keys: results, data, rows
          if (Array.isArray(data.results)) data = data.results;
          else if (Array.isArray(data.data)) data = data.data;
          else if (Array.isArray(data.rows)) data = data.rows;
        }

        this.advanceListData = Array.isArray(data) ? data : [];
        this.showAdvanceModal = true;
      } catch (error) {
        console.error('Error fetching advance list count:', error);
        toast.error(error.response?.data?.message || 'Error fetching advance list');
      } finally {
        this.isLoadingAdvanceList = false;
      }
    },
    async fetchPorts() {
      try {
        const response = await axios.get('/port');
        var data = response.data[2]
        data.push({ portid: 0, name: 'Choose One', description: 'Choose One', PortCode: '' })
        localStorage.setItem('ports', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching ports:', error);
      } finally {
        //console.log(localStorage.getItem('ports'))
      }
    },
    async fetchMovements() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/movement_list', config);
        var data = response.data[2]
        data.push({ Movid: 0, Name: 'Select movement' })
        localStorage.setItem('movements', JSON.stringify(data));
        //console.log(localStorage.getItem('movements'))
      } catch (error) {
        console.error('Error fetching movement list:', error);
      }
    },
    async fetchStates() {
      try {
        const response = await axios.get('/states');
        var data = response.data[2]
        localStorage.setItem('states', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching states:', error);
        //} finally {
        //console.log(localStorage.getItem('states'))
      }
    },
    async fetchCountries() {
      try {
        const response = await axios.get('/countries');
        localStorage.setItem('countries', JSON.stringify(response.data[2]));
      } catch (error) {
        console.error('Error fetching countries:', error);
        //} finally {
        //console.log(localStorage.getItem('countries'))
      }
    },
    async fetchCFS() {
      try {
        const response = await axios.get('/cfs_locations');
        var data = response.data[2]
        data.push({ locationid: 0, Name: 'Select cfs/icd', ShortName: 'Select cfs/icd' })
        data.push({ locationid: 4000, Name: 'Party', ShortName: 'Party' })
        localStorage.setItem('cfs_location', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching countries:', error);
        //} finally {
        //console.log(localStorage.getItem('cfs_location'))
      }
    },
    async fetchBanks() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        this.isLoading = false;
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/banks', config);
        var data = response.data[2]
        data.push({ autoid: 0, BankName: 'Select banks' })
        localStorage.setItem('banks', JSON.stringify(data));

      } catch (error) {
        console.error('Error fetching banks:', error);
        //} finally {
        //console.log(localStorage.getItem('banks'))
      }
    },
    async fetchLocations() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/location_list', config);
        var data = response.data[2]
        data.push({ locationid: 0, Name: 'Select location', ShortName: 'Select location' })
        data.push({ locationid: 4000, Name: 'Party', ShortName: 'Party' })
        localStorage.setItem('locations', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching location list:', error);
        //} finally {
        //console.log(localStorage.getItem('locations'))
      }
    },
    async fetchMasterLocations() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/master_location_list', config);
        var data = response.data[2]
        data.push({ locationid: 0, Name: 'Select location', ShortName: 'Select location' })
        localStorage.setItem('Area', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching master location list:', error);
        //} finally {
        //console.log(localStorage.getItem('locations'))
      }
    },
    async fetchVessels() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        this.isLoading = false;
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/vessel_list', config);
        var data = response.data[2]
        data.push({ Vesselid: 0, Name: 'Select vessel' })
        localStorage.setItem('vessel', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching vessel list:', error);
        //} finally {
        //console.log(localStorage.getItem('vessel'))
      }
    },
    async fetchVoyages() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        };
        const response = await axios.get('/voyage_list', config);
        var data = response.data[2]
        data.push({ Voyageid: 0, Name: 'Select voyage' })
        localStorage.setItem('voyage', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching voyage list:', error);
        //} finally {
        //console.log(localStorage.getItem('voyage'))
      }
    },
    async fetchApplicants() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/applicant_list/', config);
        var data = response.data[2]
        data.push({ applicantid: 0, applicantname: 'Select applicant' })
        localStorage.setItem('applicants', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching applicant list:', error);
        //} finally {
        //console.log(localStorage.getItem('applicants'))
      }
    },
    async fetchAccounts() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/accounts/', config);
        var data = response.data[2]
        data.push({ accountid: 0, accountname: 'Select account' })
        localStorage.setItem('accounts', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching accounts:', error);
        //} finally {
        //console.log(localStorage.getItem('accounts'))
      }
    },
    async fetchLinkedParty() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/linkParties', config);
        var data = response.data[2]
        data.push({ autoid: 0, short_name: 'Select Party' })
        localStorage.setItem('party', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching party:', error);
        //} finally {
        //console.log(localStorage.getItem('party'))
      }
    },
    async fetchActiveVCNs() {
      this.isLoadingActiveVCNs = true;
      try {
        const token = localStorage.getItem('access_token');
        const config = token ? { headers: { accept: 'application/json', Authorization: `Bearer ${token}` } } : {};
        const response = await axios.get('/active_vcn_list', config);
        // API returns data in [status, message, data] pattern in many places
        const data = Array.isArray(response.data) && response.data.length >= 3 ? response.data[2] : response.data;
        //console.log('Fetched active VCNs:', data);
        this.activeVCNs = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('Error fetching active VCNs:', error);
        this.activeVCNs = [];
      } finally {
        this.isLoadingActiveVCNs = false;
      }
    },
    async fetchActiveImportVCNs() {
      this.isLoadingactiveImortVCNs = true;
      try {
        const token = localStorage.getItem('access_token');
        const config = token ? { headers: { accept: 'application/json', Authorization: `Bearer ${token}` } } : {};
        const response = await axios.get('/get_active_import_vcn', config);
        // API returns data in [status, message, data] pattern in many places
        const data = Array.isArray(response.data) && response.data.length >= 3 ? response.data[2] : response.data;
        //console.log('Fetched active VCNs:', data);
        this.activeImortVCNs = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('Error fetching active VCNs:', error);
        this.activeImortVCNs = [];
      } finally {
        this.isLoadingactiveImortVCNs = false;
      }
    },
    async saveEdit() {
      const toast = useToast();
      if (!this.newVcn) return;
      this.isSavingEdit = true;
      //console.log('Edit VCN data to save:', this.newVcn);
      try {
        const formattedVcn = { ...this.newVcn };
        //console.log('Saving edited VCN:', formattedVcn);
        if (formattedVcn.IsSail === 1) {
          if (formattedVcn.SailDate == '' || formattedVcn.SailDate == null) {
            useToast().error('Please enter Sail Date');
            this.isSavingEdit = false;
            return;
          }
          if (cs.isvalidDate(formattedVcn.SailDate) == false) {
            useToast().error('Invalid Sail Date');
            this.isSavingEdit = false;
            return;
          }
        }
        formattedVcn.SailDate = cs.ConvertToISODate(formattedVcn.SailDate)
        const token = localStorage.getItem('access_token');
        if (!token) {
          console.error('No token found in localStorage');
          return;
        }
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        // Try calling update endpoint; fallback to local update if endpoint not available
        try {
          const res = await axios.put(`/update_vcn/${formattedVcn.vcnID}/`, formattedVcn, config);
          //console.log('Update response:', res);
          if (res.data && res.data[0] == 1) {
            // Remove the updated row from the activeVCNs list
            this.activeVCNs = this.activeVCNs.filter(vcn => vcn.vcnID !== formattedVcn.vcnID);

            toast.success('VCN updated and removed from the active list.');
          } else {
            throw new Error(res.data[1] || 'Update failed');
          }

        } catch (apiErr) {
          console.warn('update_vcn API failed or not available, removing row locally', apiErr);
          // Fallback: remove the row locally so it no longer appears in the active list
          this.activeVCNs = this.activeVCNs.filter(vcn => vcn.vcnID !== formattedVcn.vcnID);
          toast.success('VCN removed from the active list (local fallback).');
        }
        this.showEditModal = false;
        this.newVcn = null;
      } catch (error) {
        console.error('Error saving edit:', error);
      } finally {
        this.isSavingEdit = false;
      }
    },
  }
}

</script>

<style scoped>
.dashboard {
  padding: 20px;
}

.widgets {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.widgets-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

/* Responsive breakpoints similar to Bootstrap's grid */
@media (max-width: 1199.98px) {

  /* xl down -> 3 columns */
  .widgets-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 991.98px) {

  /* lg down -> 2 columns */
  .widgets-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 575.98px) {

  /* sm down -> 1 column */
  .widgets-grid {
    grid-template-columns: 1fr;
  }
}

.widget-card {
  position: relative;
  padding: 0px 16px 16px 16px;
  border-radius: 12px;
  /* glossy gradient background */
  background: linear-gradient(180deg, #ffffff 0%, #f4f8ff 40%, #e9f2ff 100%);
  /* subtle translucent border to enhance 'card' feel */
  border: 1px solid rgba(255, 255, 255, 0.6);
  /* outer shadow + slight inner highlight for depth */
  box-shadow: 0 6px 18px rgba(11, 34, 71, 0.10), inset 0 1px 0 rgba(255, 255, 255, 0.7);
  overflow: hidden;
  transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
}

/* glossy reflection */
.widget-card::after {
  content: '';
  position: absolute;
  left: -50%;
  top: -60%;
  width: 200%;
  height: 120%;
  background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.45) 0%, rgba(255, 255, 255, 0) 40%);
  transform: rotate(25deg);
  opacity: 0.6;
  pointer-events: none;
}

.widget-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px rgba(11, 34, 71, 0.16);
}

.widget-card h3 {
  /* make header span full width of the card (edge-to-edge inside padding) */
  display: block;
  margin: 0 -16px 12px -16px;
  /* extend to card inner edges (card padding = 16px) */
  padding: 10px 16px;
  border-radius: 12px 12px 0 0;
  /* match card top corners */
  /* stronger banner background that spans full width */
  background: linear-gradient(90deg, rgba(11, 58, 140, 0.12) 0%, rgba(11, 58, 140, 0.06) 100%);
  color: #07326a;
  /* deeper blue header */
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.6);
  text-align: center;
}

.widget-count {
  font-size: 28px;
  font-weight: 700;
  color: #007bff;
  margin: 8px 0 12px 0;
  cursor: pointer;
  text-align: center;
  display: block;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  width: 90%;
  max-width: 1000px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  /* make it a positioned container so nested overlay can be absolute inside */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.modal-body {
  padding: 16px;
  /* fixed height for modal content area to keep header/footer visible
     and make the content scrollable. Use max-height as a safety for
     small screens so it never exceeds viewport. */
  height: 480px;
  max-height: 60vh;
  overflow: auto;
}

.modal-footer {
  padding: 12px 16px;
  border-top: 1px solid #eee;
  text-align: right;
}

.close-btn {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

.vcns-table {
  width: 100%;
  border-collapse: collapse;
}

.vcns-table th,
.vcns-table td {
  padding: 8px 10px;
  border: 1px solid #eee;
  text-align: left;
}

.vcns-table th {
  background: #f5f5f5;
}

.search-input {
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 360px;
  max-width: 60%;
}

.search-inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-label {
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

.cancel-button {
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  background: #6c757d;
  color: #fff;
  cursor: pointer;
}

.edit-button {
  padding: 6px 10px;
  border-radius: 4px;
  border: none;
  background: #007bff;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}

.edit-button:hover {
  background: #0056b3;
}

/* Edit modal form grid */
.edit-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 16px;
  align-items: center;
}

.edit-grid label {
  font-weight: 600;
}

.save-button {
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  background: #28a745;
  color: #fff;
  cursor: pointer;
}

.save-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Nested modal (renders on top of a parent modal's content) */
.nested-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  /* sits above modal content */
}

.nested-modal-content {
  background: #fff;
  width: 90%;
  max-width: 900px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}
</style>
